import { useEffect, useState } from "react";
import { api, formatErr } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";
import { toast } from "sonner";

const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

export default function EmployeeSalary() {
  const now = new Date();
  const [month, setMonth] = useState(now.getMonth() + 1);
  const [year, setYear] = useState(now.getFullYear());
  const [requests, setRequests] = useState([]);

  const load = () => api.get("/salary/requests").then((r) => setRequests(r.data));
  useEffect(() => { load(); }, []);

  const submitRequest = async () => {
    try {
      const fd = new FormData();
      fd.append("month", month);
      fd.append("year", year);
      await api.post("/salary/request", fd);
      toast.success("Salary request submitted");
      load();
    } catch (err) { toast.error(formatErr(err)); }
  };

  const badge = (s) => ({
    pending: "bg-amber-50 text-amber-700 border-amber-300",
    processing: "bg-[#4F46E5]/10 text-[#4F46E5] border-[#4F46E5]/30",
    paid: "bg-emerald-50 text-emerald-700 border-emerald-300",
  }[s] || "bg-zinc-100 dark:bg-zinc-800");

  return (
    <div className="space-y-6" data-testid="employee-salary-page">
      <div>
        <div className="inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-[0.14em] text-indigo-600 mb-2">03 / Request</div>
        <h1 className="rule-text text-3xl sm:text-4xl text-zinc-900 dark:text-zinc-100">Salary.</h1>
      </div>

      <div className="bg-white dark:bg-zinc-900 border border-zinc-100 dark:border-zinc-800 rounded-xl shadow-sm p-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 items-end">
        <div>
          <Label className="eyebrow">Month</Label>
          <Select value={String(month)} onValueChange={(v) => setMonth(Number(v))}>
            <SelectTrigger className="rounded-xl mt-1" data-testid="req-month"><SelectValue /></SelectTrigger>
            <SelectContent>{MONTHS.map((m, i) => <SelectItem key={i} value={String(i+1)}>{m}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <div>
          <Label className="eyebrow">Year</Label>
          <Input type="number" value={year} onChange={(e) => setYear(Number(e.target.value))} className="rounded-xl mt-1" data-testid="req-year" />
        </div>
        <Button className="klein-btn rounded-xl uppercase tracking-[0.2em] text-xs font-bold h-10 md:col-start-4" onClick={submitRequest} data-testid="submit-salary-request-btn">Raise Request</Button>
      </div>

      <div className="bg-white dark:bg-zinc-900 border border-zinc-100 dark:border-zinc-800 rounded-xl shadow-sm overflow-x-auto">
          <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="text-[11px] font-semibold uppercase tracking-wider text-zinc-500 dark:text-zinc-400 dark:text-zinc-500">Period</TableHead>
              <TableHead className="text-[11px] font-semibold uppercase tracking-wider text-zinc-500 dark:text-zinc-400 dark:text-zinc-500">Requested At</TableHead>
              <TableHead className="text-[11px] font-semibold uppercase tracking-wider text-zinc-500 dark:text-zinc-400 dark:text-zinc-500">Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {requests.length === 0 ? (
              <TableRow><TableCell colSpan={3} className="text-center py-12 text-zinc-500 dark:text-zinc-400 text-sm">No salary requests yet.</TableCell></TableRow>
            ) : requests.map((r) => (
              <TableRow key={r.id} data-testid={`salary-req-row-${r.id}`}>
                <TableCell className="font-mono">{String(r.month).padStart(2,"0")}/{r.year}</TableCell>
                <TableCell>{r.created_at?.slice(0,10)}</TableCell>
                <TableCell><span className={`eyebrow px-2 py-1 border ${badge(r.status)}`}>{r.status}</span></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
